// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"toolbar_wrapper__2W0eh","titles":"toolbar_titles__8sd4K","title":"toolbar_title__3PkCR","isActive":"toolbar_isActive__2TLQ1","logout":"toolbar_logout__3Ldzk"};